import { CeilingLightMultipleIcon } from './CeilingLightMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 95F3D89F-8AE6-4B86-BFE7-7D6A27018E7D
 * name ceiling-light-multiple
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light-multiple.svg
 * tags
 * - Home Automation 
 */
export const CeilingLampMultipleIcon = CeilingLightMultipleIcon;
export default CeilingLampMultipleIcon